const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CATEGORIES = [
  'Donor & funder writing',
  'Data & reports',
  'Vernacular & translation',
  'Automation',
  'Policy & governance',
  'Other',
];

export const FILTERS = ['All', ...CATEGORIES];
export const WORKS_IN = ['Claude', 'Gemini', 'Any LLM'];

// ── Public API ──
export async function fetchPosts({ category = 'All', sort = 'top' } = {}) {
  const params = new URLSearchParams({ sort });
  if (category && category !== 'All') params.set('category', category);
  const res = await fetch(`${API}/exchange/posts?${params.toString()}`);
  if (!res.ok) throw new Error('Failed to load posts');
  return res.json();
}

export async function fetchPost(id) {
  const res = await fetch(`${API}/exchange/posts/${id}`);
  if (!res.ok) throw new Error('Post not found');
  return res.json();
}

export async function createPost(data) {
  const res = await fetch(`${API}/exchange/posts`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error('Failed to publish');
  return res.json();
}

export async function upvotePost(id) {
  const res = await fetch(`${API}/exchange/posts/${id}/upvote`, { method: 'POST' });
  if (!res.ok) throw new Error('Failed to upvote');
  return res.json();
}

// ── Curator (admin) ──
export async function curatorLogin(passphrase) {
  const res = await fetch(`${API}/exchange/admin/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ passphrase }),
  });
  return res.ok;
}

export async function fetchAllPosts(passphrase) {
  const res = await fetch(`${API}/exchange/admin/posts`, {
    headers: { 'X-Curator-Key': passphrase },
  });
  if (!res.ok) throw new Error('Unauthorized');
  return res.json();
}

export async function toggleEndorse(id, passphrase) {
  const res = await fetch(`${API}/exchange/posts/${id}/endorse`, {
    method: 'PATCH',
    headers: { 'X-Curator-Key': passphrase },
  });
  if (!res.ok) throw new Error('Failed');
  return res.json();
}

export async function deletePost(id, passphrase) {
  const res = await fetch(`${API}/exchange/posts/${id}`, {
    method: 'DELETE',
    headers: { 'X-Curator-Key': passphrase },
  });
  if (!res.ok) throw new Error('Failed');
  return res.json();
}

// ── Register interest ──
export async function createInterest(data) {
  const res = await fetch(`${API}/interest`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error('Failed to submit');
  return res.json();
}

export async function fetchInterest(passphrase) {
  const res = await fetch(`${API}/interest/admin`, {
    headers: { 'X-Curator-Key': passphrase },
  });
  if (!res.ok) throw new Error('Unauthorized');
  return res.json();
}

// ── LocalStorage vote dedup (one vote per post per device) ──
const VOTES_KEY = 'ai_lab_exchange_votes';

export function getVotedIds() {
  try {
    return JSON.parse(localStorage.getItem(VOTES_KEY) || '[]');
  } catch {
    return [];
  }
}

export function hasVoted(id) {
  return getVotedIds().includes(id);
}

export function addVoted(id) {
  const ids = getVotedIds();
  if (!ids.includes(id)) {
    ids.push(id);
    localStorage.setItem(VOTES_KEY, JSON.stringify(ids));
  }
}

// ── Relative time ──
export function timeAgo(iso) {
  if (!iso) return '';
  const then = new Date(iso).getTime();
  const s = Math.max(0, (Date.now() - then) / 1000);
  if (s < 60) return 'just now';
  const m = s / 60;
  if (m < 60) return `${Math.floor(m)}m ago`;
  const h = m / 60;
  if (h < 24) return `${Math.floor(h)}h ago`;
  const d = h / 24;
  if (d < 7) return `${Math.floor(d)}d ago`;
  const w = d / 7;
  if (w < 5) return `${Math.floor(w)}w ago`;
  return new Date(iso).toLocaleDateString();
}
